enum PageTypeEnum {
  junior = 1,
  high,
}

const storageKey = {
  [PageTypeEnum.junior]: 'JUNIOR_CARD_LIST',
  [PageTypeEnum.high]: 'SENIOR_CARD_LIST',
}
const coinPerCard = {
  [PageTypeEnum.junior]: 10,
  [PageTypeEnum.high]: 200,
}
const shuffleArr = (arr: Array<any>) => {
  const tempArr = [].concat(arr)
  // eslint-disable-next-line no-plusplus
  for (let i = 1; i < tempArr.length; i++) {
    const random = Math.floor(Math.random() * (i + 1))
    ;[tempArr[i], tempArr[random]] = [tempArr[random], tempArr[i]]
  }
  return tempArr
}
// 不同颜色的卡牌的名称 想要每次新进的时候卡牌颜色的排序都不一样
const cardList = [
  'hiya',
  'red',
  'yellow',
  'blue',
  'green',
  'hiya',
  'red',
  'yellow',
  'blue',
  'green',
]
// 刮卡 最终结果可能会出现的图标
const resLogList = ['hiya', 'red', 'yellow', 'blue', 'green']
// 刮卡 胜利图标
const winLogList = [].concat(resLogList, resLogList.slice(1))
// 刮卡 失败图标
const failLogList = [].concat(resLogList.slice(1), resLogList.slice(1), [
  resLogList.slice(1)[Math.floor(Math.random() * resLogList.slice(1).length)],
])
// 获取刮开的log的二维数组 3*3的数组
// 如果是胜利的话，会包含一个hiya logo
// 如果失败的话，剩余的4种logo *2 再加上一个随机颜色的logo
const getLogArr = (isWin = false) => {
  // 乱序数组
  const baseArr = shuffleArr(isWin ? winLogList : failLogList)
  const res = []
  // 每行显示3个
  const n = 3
  const lineNum =
    baseArr.length % n === 0
      ? baseArr.length / n
      : Math.floor(baseArr.length / n + 1)
  for (let i = 0; i < lineNum; i += 1) {
    const temp = baseArr.slice(i * n, i * n + n)
    res.push(temp)
  }
  return res
}
const getLogoSrc = (key: 'hiya' | 'red' | 'yellow' | 'blue' | 'green') => {
  const logsPng = require.context(`./images/logos`, false)
  const src = logsPng.keys().find((v) => {
    return v.indexOf(`${key}`) !== -1
  })
  return src && logsPng(src)
}
const getImageSrc = ({
  pageTabIndex,
  key,
}: {
  pageTabIndex: PageTypeEnum
  key: 'hiya' | 'red' | 'yellow' | 'blue' | 'green'
}) => {
  const cards = {
    [PageTypeEnum.junior]: require.context(`./images/cards`, false),
    [PageTypeEnum.high]: require.context(`./images/cards/high`, false),
  }[pageTabIndex]
  const src = cards.keys().find((v) => {
    return v.indexOf(`${key}`) !== -1
  })
  return src && cards(src)
}
const getScratchAreaSrc = ({
  pageTabIndex,
  key,
}: {
  pageTabIndex: PageTypeEnum
  key: 'hiya' | 'red' | 'yellow' | 'blue' | 'green'
}) => {
  const cardsPng = require.context('./images/scratchArea', false)
  const highCardsPng = require.context(`./images/scratchArea/high`, false)
  const src = (pageTabIndex === PageTypeEnum.high ? highCardsPng : cardsPng)
    .keys()
    .find((v) => {
      return v.indexOf(`${key}`) !== -1
    })
  return (
    src && (pageTabIndex === PageTypeEnum.high ? highCardsPng : cardsPng)(src)
  )
}
const getStorageKeys = (pageTabIndex: PageTypeEnum) => {
  if (typeof window !== 'undefined') {
    if (
      !window.localStorage ||
      !window.localStorage.getItem(storageKey[pageTabIndex])
    ) {
      return ''
    }
    return window.localStorage.getItem(storageKey[pageTabIndex])
  }
  return ''
}
const setStorageKeys = (pageTabIndex: PageTypeEnum, keys: string) => {
  if (typeof window === 'undefined') {
    return
  }
  window.localStorage.setItem(storageKey[pageTabIndex], keys)
}
export {
  cardList,
  coinPerCard,
  failLogList,
  getImageSrc,
  getLogArr,
  getLogoSrc,
  getScratchAreaSrc,
  getStorageKeys,
  setStorageKeys,
  shuffleArr,
  storageKey,
  winLogList,
}
